export const isServer = typeof window === 'undefined';

export const isTest = process.env.NODE_ENV === 'test';

export const isClientApiRequest = req =>
    Boolean(req?.url?.startsWith('/_next/data'));

export const isNextJs = isServer || document.getElementById('__next') !== null;
